/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect } from 'react';
import { FieldError, FieldPath, FieldValues } from 'react-hook-form';
import { FormField } from '@/components/HookForm';
import Input, { IInputProps } from '@/components/Input';
import ResentOTP, { IResentOtpProps } from './ResentOTP';
import ResentOTPAdornment from './ResentOtpAdornment';

export interface IOTPInputFieldProps<TFieldValues extends FieldValues>
  extends IInputProps {
  name: FieldPath<TFieldValues>;
  onSendOTP: () => void | Promise<void>;
  isSendOnMount?: boolean;
  timeout?: number;
  resentOtpProps?: Pick<IResentOtpProps, 'title' | 'buttonTitle'>;
  errorHandler?: (__error: FieldError) => ReactNode;
  isTimerOnEndAdornment?: boolean;
  isLoading?: boolean;
  isRequired?: boolean;
  isFullWidth?: boolean;
}

const OTPInputField = <TFieldValues extends {}>({
  name,
  onSendOTP,
  timeout = 90,
  resentOtpProps,
  errorHandler,
  isTimerOnEndAdornment = false,
  isLoading = false,
  isSendOnMount = false,
  isRequired = false,
  isFullWidth = false,
  ...props
}: IOTPInputFieldProps<TFieldValues>) => {
  useEffect(() => {
    if (isSendOnMount) {
      onSendOTP();
    }
  }, []);

  return (
    <>
      <FormField
        classNames={{
          formFieldRoot: isFullWidth ? 'w-full' : '',
        }}
        errorHandler={errorHandler}
        isRequired={isRequired}
        name={name}
        render={({ field }) => (
          <Input
            autoComplete="one-time-code"
            endAdornment={
              isTimerOnEndAdornment && (
                <ResentOTPAdornment
                  isLoading={isLoading}
                  timeout={timeout}
                  onResend={onSendOTP}
                  {...resentOtpProps}
                />
              )
            }
            maxLength={8}
            isNumeric
            {...props}
            {...field}
          />
        )}
      />
      {!isTimerOnEndAdornment && (
        <ResentOTP timeout={timeout} onResend={onSendOTP} {...resentOtpProps} />
      )}
    </>
  );
};

export default OTPInputField;
